import React, { useCallback, useEffect, useState } from 'react'
import APIService from '../../Services/API/APIService'
import { Loader, Table, Dimmer } from 'semantic-ui-react'
import dayjs from 'dayjs'
import { toast } from 'react-toastify'

const AuditTrails = (props) => {

  const [loading, setLoading] = useState(false)
  const [audit, setAuditItems] = useState(null)

  const fetchData = useCallback(async (isSubscribed) => {
    try {
      setLoading(false)

      let response = await APIService.getData('/guest-house/audit-trails', {
        bookingId: props?.audit?.bookingId || props?.audit?.orderId
      })
      if(isSubscribed){
        setAuditItems(response)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      toast.warn(error)
    }
  },[props?.audit])

  useEffect(() => {
    let isSubscribed = true
    fetchData(isSubscribed)

    return () => (isSubscribed = false)

  }, [fetchData])

  let counter = 0

  const auditItems = audit?.map((item,index) => (

    <Table.Row key={index}>

      <Table.Cell> {counter = counter + 1}</Table.Cell>

      <Table.Cell>{item?.username}</Table.Cell>
      <Table.Cell>
        {item.action}
      </Table.Cell>
      <Table.Cell>{item.bookingCode}</Table.Cell>
      <Table.Cell>{dayjs(item.createdAt).format("DD-MMM-YYYY")}</Table.Cell>


    </Table.Row>
  ));
  return (
    <div>
      {loading && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}
      {audit && (
        <Table striped stackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>S/N</Table.HeaderCell>
              <Table.HeaderCell>Email</Table.HeaderCell>
              <Table.HeaderCell>Action</Table.HeaderCell>
              <Table.HeaderCell>Booking ID</Table.HeaderCell>
              <Table.HeaderCell>Date</Table.HeaderCell>

            </Table.Row>
          </Table.Header>

          <Table.Body>{auditItems}</Table.Body>
        </Table>
      )}

    </div>
  )
}

export default AuditTrails